import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useField } from 'formik'
import { ClickAwayListener, Grid, IconButton, InputAdornment, Tooltip } from '@mui/material'
import { Info } from '@dhl/icons'
import { EmailInput, TextFieldInput } from '@dhl/inputs'
import { PaperSection } from '~/widgets'

type Props = {
  showDescriptionField: boolean
  showReferenceField: boolean
  showEmailInfo?: boolean
}

export const ContactDetails = ({ showDescriptionField, showReferenceField, showEmailInfo }: Props) => {
  const { t } = useTranslation()
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const [, { value: returnType }] = useField('returnType')

  const handleTooltipClose = () => {
    setTooltipOpen(false)
  }

  const handleTooltipOpen = () => {
    setTooltipOpen(true)
  }

  return (
    <PaperSection title={t('contactDetails')}>
      <Grid container direction="column" spacing={2} size={{ xs: 12 }}>
        <Grid>
          <TextFieldInput
            name="companyName"
            type="text"
            label={t('inputs.name.companyName')}
            fullWidth
            required={returnType === 'pickup'}
          />
        </Grid>
        <Grid>
          <TextFieldInput name="firstName" type="text" label={t('inputs.name.firstName')} fullWidth required />
        </Grid>
        <Grid>
          <TextFieldInput name="lastName" type="text" label={t('inputs.name.lastName')} fullWidth required />
        </Grid>
        <Grid>
          <EmailInput
            name="email"
            fullWidth
            required
            slotProps={{
              input: {
                endAdornment: showEmailInfo ? (
                  <InputAdornment position="end">
                    <ClickAwayListener onClickAway={handleTooltipClose}>
                      <div>
                        <Tooltip
                          onClose={handleTooltipClose}
                          open={tooltipOpen}
                          disableFocusListener
                          disableHoverListener
                          disableTouchListener
                          title={t('inputs.emailInput.emailReturnLabelInfoTooltip') || ''}
                        >
                          <IconButton onClick={handleTooltipOpen} size="large">
                            <Info />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </ClickAwayListener>
                  </InputAdornment>
                ) : undefined,
              },
            }}
          />
        </Grid>
        {showDescriptionField && (
          <Grid>
            <TextFieldInput name="description" type="text" label={t('inputs.description.label')} fullWidth />
          </Grid>
        )}
        {showReferenceField && (
          <Grid>
            <TextFieldInput
              name="reference"
              type="text"
              label={t('inputs.reference.label')}
              fullWidth
              required
              autoComplete="cc-csc"
            />
          </Grid>
        )}
      </Grid>
    </PaperSection>
  )
}
